import React, { useState, useRef, useEffect } from 'react';

const Piano = (props) => {

    const [page, setPage] = useState(1);
    const [musicPlaying, setMusicPlaying] = useState(false);
    const [musicTime, setMusicTime] = useState(0);
    const [cursorPos, setCursorPos] = useState(0);

    const dirName = props.dirName;
    const musicName = props.musicName;
    const numberOfPages = props.numberOfPages;
    const pageSpeeds = props.pageSpeeds;
    const callback = props.callback ? props.callback : (musicTime, paused) => { };
    const width = props.width ? props.width : 650;
    const height = props.height ? props.height : 145;

    //Timecodes array is created by adding all the previous page speeds to the current page speed
    const timecodes = pageSpeeds.reduce((acc, curr, index) => {
        if (index === 0) {
            acc.push(curr);
        } else {
            acc.push(acc[index - 1] + curr);
        }
        return acc;
    }, []);
    //timecode of the first page is 0
    timecodes.unshift(0);

    const audioPlayer = useRef();
    let duration = audioPlayer.current ? audioPlayer.current.duration : 0;

    useEffect(() => {
        /*
        Update is too slow for the timeupdate event
        audioPlayer.current.addEventListener('timeupdate', () => {
            setMusicTime(audioPlayer.current.currentTime);
        });*/
        setInterval(function () {
            setMusicTime(audioPlayer.current.currentTime);
        }, 30);
    }, []);

    //since all pages have different speeds, we need to update using the timecodes array
    useEffect(() => {
        if (musicTime <= duration && page <= numberOfPages) {
            let page = 0;
            for (let i = 0; i < timecodes.length; i++) {
                if (musicTime >= timecodes[i]) {
                    page = Math.min(i + 1, numberOfPages);
                }
            }
            setPage(page);
        } else {
            setPage(1);
            reset();
        }
        //console.log(`musicTime: ${musicTime}, duration: ${duration}, page: ${page}`);
    }, [musicTime]);

    //We need to update the place of the cursor depending on the musicTime and pageSpeeds
    useEffect(() => {
        const offset = timecodes[page - 1];
        //d = v*t
        setCursorPos(width / pageSpeeds[page - 1] * (musicTime - offset));
    }, [musicTime, page]);

    //Calling the callback with musicTime at every update
    useEffect(() => {
        callback(musicTime, !musicPlaying);
    }, [musicTime, musicPlaying]);

    const playMusic = () => {
        audioPlayer.current.play();
        setMusicPlaying(true);
    }

    const pauseMusic = () => {
        audioPlayer.current.pause();
        setMusicPlaying(false);
    }

    const pageClickHandler = (page) => {
        audioPlayer.current.currentTime = timecodes[page - 1];
    }

    const reset = () => {
        audioPlayer.current.currentTime = 0;
        pauseMusic();
    }

    const clickHandler = (e) => {
        const bounds = e.currentTarget.getBoundingClientRect();
        const x = e.clientX - bounds.left;
        const y = e.clientY - bounds.top;
        if (x > 10 && x < width+10 && y > 0 && y < height+10) {
            audioPlayer.current.currentTime = (x - 10) / width * pageSpeeds[page - 1] + timecodes[page - 1];
        }
    }

    const rows = [];
    for (let i = 0; i < numberOfPages; i++) {
        rows.push(
            <div key={i}
                onClick={() => pageClickHandler(i + 1)}
                style={{ position: 'absolute', left: `${i * 30 + 135}px`, top: height + 15, zIndex: 8 }}
            >
                <img
                    src={
                        i + 1 === page ? process.env.PUBLIC_URL + "/assets/images/piano/circle.svg" : process.env.PUBLIC_URL + "/assets/images/piano/circle_clicked.svg"
                    }
                    alt="page" //PB8
                    style={{ position: 'absolute', left: '0px', top: '2px' }} /> 
                <p
                    style={{ position: 'absolute', left: '0px', top: '-14px', width: '20px', userSelect: 'none', color: 'white', textAlign: 'center' }}>
                    {i + 1}
                </p>
            </div>);
    }

    return (
        <>
            <div className='background' />
            <div className={props.className ? props.className + ' piano' : 'piano'}
                style={{ position: 'absolute', ...props.style }}
                onClick={clickHandler}
            >
                <img
                    src={process.env.PUBLIC_URL + "/assets/images/" + dirName + "/" + page + ".jpg"}
                    alt="piano"
                    style={{ position: 'absolute', left: '10px', top: '0px', width: width, height: height, zIndex: 6 }} />
                <img
                    src={process.env.PUBLIC_URL + "/assets/images/piano/pianokey.png"}
                    alt="pianokey"
                    style={{ position: 'absolute', left: '0px', top: '0px', height: height + 11, width: width + 10, zIndex: 3, objectFit: 'cover', objectPosition: 'left' }} />
                <img
                    src={process.env.PUBLIC_URL + "/assets/images/piano/bar.jpg"}
                    alt="bar"
                    style={{ position: 'absolute', left: '10px', top: height, width: width, objectFit: 'cover' }} />
                <img
                    src={
                        !musicPlaying ? process.env.PUBLIC_URL + "/assets/images/piano/play.svg" : process.env.PUBLIC_URL + "/assets/images/piano/play_clicked.svg"
                    }
                    alt="play"
                    onClick={playMusic}
                    style={{ position: 'absolute', left: '20px', top: height + 23, zIndex: 8 }} />

                <img
                    src={
                        musicPlaying ? process.env.PUBLIC_URL + "/assets/images/piano/pause.svg" : process.env.PUBLIC_URL + "/assets/images/piano/pause_clicked.svg"
                    }
                    alt="pause"
                    onClick={pauseMusic}
                    style={{ position: 'absolute', left: '40px', top: height + 23, zIndex: 8 }} />

                <img
                    src={process.env.PUBLIC_URL + "/assets/images/piano/back.svg"}
                    alt="back"
                    onClick={reset}
                    style={{ position: 'absolute', left: '60px', top: height + 23, zIndex: 8 }} />

                {numberOfPages > 1 && <div className='page' style={{ position: 'absolute', left: '25px', top: '5px' }}>
                    <span style={{ position: 'absolute', left: '90px', top: height + 15, color: 'white' }}>
                        page
                    </span>
                    {rows}
                </div>}
                <svg style={{ position: 'absolute', top: '0px', left: '10px', width: width, height: height, zIndex: 12 }}>
                    {/*cursor*/}
                    <line x1={cursorPos} y1="0" x2={cursorPos} y2={height} stroke="red" strokeWidth={2} />
                </svg>
                <audio
                    id="audio"
                    src={process.env.PUBLIC_URL + "/assets/sounds/" + musicName + ".mp3"}
                    controls
                    preload='true'
                    style={{ display: 'none', position: 'absolute' }}
                    ref={audioPlayer} />

            </div>
        </>
    );
}

export default Piano;
